import { Card, Skeleton, Space } from 'antd';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import NewDisciplineChangeRequestApiService from '../../../../api/NewDisciplineChangeRequestApiService';
import ChangeRequestLayout from '../../../../components/postSecondary/ChangeRequestLayout';
import NewDisciplineChangeRequestDetails from '../../../../components/displays/postSecondary/NewDisciplineChangeRequestDetails';
import ChangeRequestReviewForm from '../../../../components/forms/postSecondary/ChangeRequestReviewForm';
import Routes from '../../../../config/Routes';
import ChangeRequestStatusType from '../../../../consts/ChangeRequestStatusType';
import * as GetNewDisciplineChangeRequestHandler from '../../../../handlerModels/GetNewDisciplineChangeRequestHandler';
import ChangeRequestDTO from '../../../../models/ChangeRequestDTO';
import InstitutionDTO from '../../../../models/InstitutionDTO';
import UserSecurity from '../../../../models/UserSecurity';
import BaseFormState from '../../../../redux/bases/BaseFormState';
import { StateStoreModel } from '../../../../redux/state/StateStoreModel';
import Guid from '../../../../utils/Guid';
import HistoryUtil from '../../../../utils/HistoryUtil';
import ParameterUtil from '../../../../utils/ParameterUtil';

interface NewDisciplineChangeRequestReviewPageState extends BaseFormState {
  changeRequestId: string;
  changeRequest: ChangeRequestDTO;
}

interface NewDisciplineChangeRequestReviewPageProps {
  currentUser: UserSecurity | null;
  selectedInstitution: InstitutionDTO | null;
}

class NewDisciplineChangeRequestReviewPage extends React.Component<NewDisciplineChangeRequestReviewPageProps & RouteComponentProps<RouteObject>, NewDisciplineChangeRequestReviewPageState> {
  constructor(props: NewDisciplineChangeRequestReviewPageProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      changeRequestId: Guid.Empty(),
      changeRequest: ChangeRequestDTO.create(),
    };
  }

  componentDidMount() {
    const id = ParameterUtil.getPathPart(this.props.match, 'id');

    if (id !== Guid.Empty() && this.state.changeRequestId != id) {
      this.setState({ changeRequestId: id });
      this.fetchData(id);
    }
  }

  private fetchData = (id: string) => {
    this.setState({ loading: true });

    const loaders = [];

    if (id !== Guid.Empty()) {
      loaders.push(this.loadChangeRequest(id));
    }

    Promise.all(loaders).then(() => {
      this.setState({ loading: false });
    });
  }

  private loadChangeRequest = (id: string) => {
    const request = GetNewDisciplineChangeRequestHandler.Request.create({
      changeRequestId: id
    });

    return NewDisciplineChangeRequestApiService.get(request)
      .then((results: GetNewDisciplineChangeRequestHandler.Result) => {
        if (results) {
          this.setState({
            changeRequest: results.changeRequest ?? ChangeRequestDTO.create(),
            fieldErrors: results.fieldErrors
          });
        }
      }).catch(() => {
        this.setState({ error: true, message: 'Could not load change request.' });
      });
  }

  goToPreviousStep = () => {
    HistoryUtil.push(Routes.generate(Routes.EXISTING_NEW_DISCIPLINE_CHANGE_REQUEST_ENTRY_2, { id: this.state.changeRequestId }, {}))
  }

  goToNextStep = () => {
    HistoryUtil.push(Routes.generate(Routes.EXISTING_NEW_DISCIPLINE_CHANGE_REQUEST_ENTRY_SUBMITTED, { id: this.state.changeRequestId }, {}))
  }

  render() {
    if (this.state.loading) {
      return <Skeleton active={true} />;
    }

    return (
      <ChangeRequestLayout
        changeRequest={this.state.changeRequest ?? ChangeRequestDTO.create()}
        stepNumber={2}
        currentUser={this.props.currentUser ?? {} as UserSecurity}>
        <Card title="Review" >
          <Space direction="vertical">
            <NewDisciplineChangeRequestDetails loading={this.state.loading} changeRequest={this.state.changeRequest} fieldErrors={this.state.fieldErrors} />
            <ChangeRequestReviewForm changeRequest={this.state.changeRequest} onSubmit={this.goToNextStep} onPrevious={this.goToPreviousStep} />
          </Space>
        </Card>
      </ChangeRequestLayout>
    );
  }

  showComments = () => {
    return this.state.changeRequest?.statusTypeId == ChangeRequestStatusType.ATTENTIONREQUIRED ?? false;
  }
}

function mapStateToProps(state: StateStoreModel) {
  return {
    currentUser: state.UserSession.Value,
    selectedInstitution: state.Institution.Selected
  };
}

export default withRouter(connect(mapStateToProps)(NewDisciplineChangeRequestReviewPage));